import { apiClient } from "../../Config/ApiClient";

export const indexFeed = (token) => apiClient.get(`/feeds/index`,  { headers: {'Authorization': token} });

export const stockFeed = (token) => apiClient.get(`/feeds/stock`,  { headers: {'Authorization': token} });

export const disclosureFeed = (token) => apiClient.get(`/feeds/disclosure`,  { headers: {'Authorization': token} });

export const gmsIndexFeed = (token) => apiClient.get(`/gms_feeds/index`,  { headers: {'Authorization': token} });

export const gmsStockFeed = (token) => apiClient.get(`/gms_feeds/stock`,  { headers: {'Authorization': token} });

export const gmsDisclosureFeed = (token) => apiClient.get(`/gms_feeds/disclosure`,  { headers: {'Authorization': token} });